// This function moves any elements which appear as "default" slotted elements in a web component,
// and moves these elements out of the shadow DOM and into the light DOM.
// Useful for things such as form elements, which need to be in the light DOM to be submitted,
// or elements that you want to manage as though they are shadow DOM elements (receive prop updates, etc.) but that live in the light DOM (useful for inheriting styles from main document).
//
// 💥WARNING:💥 Careful consideration should be given to the use of this function. It is generally not recommended to use this function, as it can lead to unexpected behavior when reactive updates from the server are applied to the page.

export default function moveSlotChildElementsToLightDom(
  host: HTMLElement,
  slotName: string = '',
  clearExistingSlot: boolean = true,
) {
  const shadowRoot = host.shadowRoot;
  if (shadowRoot) {
    // Get all slots in the shadowRoot that match the slotName.
    const slots = shadowRoot.querySelectorAll(
      slotName ? `slot[name="${slotName}"]` : 'slot:not([name]), slot[name=""]',
    ) as NodeListOf<HTMLSlotElement>;

    slots.forEach(slot => {
      slot = slot as HTMLSlotElement;
      const parentElement = slot.parentElement;
      // If the slot is inside another slot, then it belongs to some other nested host element.
      if (parentElement && parentElement.closest('slot')) return;

      // Delete any existing nodes that occupy this slot.
      if (clearExistingSlot) {
        slot.assignedElements().forEach(node => node.remove());
      }

      // Populate the slot with the default content which has been lifted into the light-DOM.
      const nodes = Array.from(slot.childNodes);
      // Assign each child element
      nodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // @ts-ignore
          node.slot = slotName;
        } else {
          if (node.nodeType === Node.TEXT_NODE && node?.textContent?.trim() === '') return;

          console.error(
            'All child nodes must be HTML elements. Text nodes, etc. are not allowed.',
            {
              slot,
              node,
            },
          );
        }
      });
      host.append(...nodes);
    });
  }
}
